import React from 'react'
import PropTypes from 'prop-types'
import tw, { styled } from 'twin.macro'

const GridSection = styled.section`
	${tw`pt-8 pb-16 px-4 bg-gray-50`}
`

const Container = styled.div`
	${tw`container mx-auto`}
`

const SectionTitle = styled.h2`
	${tw`text-3xl md:text-4xl font-bold text-center mb-12 text-gray-900`}
	text-transform: uppercase;
`

const TitleImage = styled.img`
	${tw`mx-auto mb-12`}

	width: 100%;
	height: auto;

	@media (min-width: 641px) {
		max-width: 400px;
		width: auto;
	}
`

const Grid = styled.div`
	${tw`grid gap-8`}
	grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
	align-items: start;
	justify-items: center;

	@media (min-width: 1024px) {
		grid-template-columns: repeat(auto-fit, minmax(320px, 400px));
		justify-content: center;
	}
`

/**
 * PromotionGrid - Container for promotion cards
 * @param {Object} props
 * @param {string} props.title - Section title (text)
 * @param {string} props.titleImage - Optional title image path (replaces text title)
 * @param {string} props.titleImageAlt - Alt text for title image
 * @param {Node} props.children - Child components (typically PromotionCard components)
 */
const PromotionGrid = ({ title, titleImage, titleImageAlt, children }) => {
	return (
		<GridSection>
			<Container>
				{titleImage ? (
					<TitleImage src={titleImage} alt={titleImageAlt || title || 'Section title'} />
				) : (
					title && <SectionTitle>{title}</SectionTitle>
				)}
				<Grid>{children}</Grid>
			</Container>
		</GridSection>
	)
}

PromotionGrid.propTypes = {
	title: PropTypes.string,
	titleImage: PropTypes.string,
	titleImageAlt: PropTypes.string,
	children: PropTypes.node.isRequired,
}

PromotionGrid.defaultProps = {
	title: null,
	titleImage: null,
	titleImageAlt: null,
}

export default PromotionGrid
